import React, { Component } from "react";
import NAERlogo from "../Images/NAER logo.png";

class Logo extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <h1 className="text-center head">Logo: Its meaning</h1>
        <div className="text-center">
          <img className="img-fluid" src={NAERlogo} alt="logo" />
        </div>
        <p>
          The “New-Age Academy of Education and Research” (NAER) is a centre
          that has a logo indicating the exhibition of the new trend in
          educating all types of learners. This is an age of learners which
          demands critical thinkers and analyzers, learners with creative ideas
          who can run with information from technological devices and related
          books, hence the Logo shows this trend with the learners in speed to
          research and to find solutions to problems of life in communities and
          in the institutions.
        </p>
        <p>
          Inclusivity, in learner’s environment is key for all children.
          Therefore, learners with Language and Speech deviations must have
          belonginess and equal opportunities in the same learning environment
          to express themselves. The hearing impaired, those with spoken
          language difficulties, the learning disabled, the Post-Stroke patients
          with Speech and Language difficulty and those with Reading
          Difficulties (Dyslexia) need support and remedial treatment to
          function as same as others.
        </p>
        <p>
          It is a centre for counselling families who have children with special
          needs. Education is therefore, a powerful tool for Development which
          refers to ‘‘a multi-dimensional process involving profound
          socio-cultural, educational and technological advancement’’. Knowledge
          is Power and skill is strength.
        </p>
      </div>
    );
  }
}

export default Logo;
